import React from 'react'
import {
	heightPercentageToDP as heightPercentage,
	widthPercentageToDP as widthPercentage,
} from '../../Utils/ResponsiveScreen'
import { KTColors } from '../Constants/KTColors'
import { fonts } from '../Constants/theme'
const styles = {
	bottomBarMain: {
		bottom: 0,
		position: 'absolute',
		paddingLeft: widthPercentage('5%'),
		paddingRight: widthPercentage('5%'),
		paddingVertical: widthPercentage('2%'),
		paddingHoriztal: widthPercentage('2%'),
	},
	UserProfileStyle: {
		flexDirection: 'row',
		alignItems: 'center',
	},
	profile: {
		maxWidth: widthPercentage('60%') - 100,
	},
	profileNameStyle: {
		fontSize: heightPercentage('2.2%'),
		color: KTColors.black,
		fontFamily: fonts.fontFamilyExtraBold,
		maxWidth: widthPercentage('60'),
	},
	handleStyle: {
		fontSize: heightPercentage('1.5%'),
		color: KTColors.black,
		fontFamily: fonts.fontFamilyLight,
		maxWidth: widthPercentage('55'),
	},
	ImageStyle: {
		marginRight: 16,
	},
	dataIDStyle: {
		fontSize: heightPercentage('1.3%'),
	},
}

class BottomBar extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			dispShowMore: false,
			explanationModal: false,
		}
	}

	render() {
		const { data, type } = this.props
		return (
			<div style={styles.bottomBarMain}>
				{type && type === 'clearUserHistory' ? (
					<div>
						<span class='row'>
							<div class='col-md-2'>
								<img
									src='dist/img/photo1.png'
									alt='User Avatar'
									style={{ height: 40, width: 40, borderRadius: '50%' }}
								/>
							</div>
							<div class='col-md-2'>
								<div>
									<p style={styles.profileNameStyle}>YouSay</p>
									<p style={styles.handleStyle}>@yousayEditor</p>
								</div>
							</div>
						</span>
						<p style={styles.dataIDStyle}>{data.PK}</p>
					</div>
				) : (
					<div>
						{

							this.props.data.contentType != 'ShortByte' &&
							<>
								<span class='row'>
									<div class='col'>
										<img
											src='dist/img/photo1.png'
											alt='User Avatar'
											style={{ height: 40, width: 40, borderRadius: '50%' }}
										/>
									</div>
									<div class='col'>
										<div>
											<p style={styles.profileNameStyle}>YouSay</p>
											<p style={styles.handleStyle}>@yousayEditor</p>
										</div>
									</div>
								</span>
							</>

						}

						<p style={styles.dataIDStyle}>{data.PK}</p>
					</div>
				)}
				{this.props.data.contentType != 'ShortByte' &&

					<div style={{ marginBottom: 0 }}>
						<p
							style={{
								color: '#CF0D66',
								textDecoration: 'underline',
								fontSize: heightPercentage('1.8%'),
								fontWeight: 'bold',
							}}
						>
							{'#Content'}
						</p>
						<p
							style={{
								color: '#CF0D66',
								textDecoration: 'underline',
								fontSize: heightPercentage('1.8%'),
								fontWeight: 'bold',
							}}
						>
							{'#Preview'}
						</p>
					</div>
				}
				<div>
					<div class='row'>
						<div
							class='col-md-6'
							style={{
								width: widthPercentage('10.5'),
								height: heightPercentage('5.5'),
								borderStyle: 'solid',
								borderRadius: 10,
								marginLeft: 10,
								marginTop: heightPercentage('0.8%'),
							}}
						></div>
						<div
							class='col-md-6'
							style={{
								width: widthPercentage('10.5'),
								height: heightPercentage('5.5'),
								borderStyle: 'solid',
								borderRadius: 10,
								marginLeft: 10,
								marginTop: heightPercentage('0.8%'),
							}}
						></div>
					</div>
				</div>
			</div>
		)
	}
}

export default BottomBar
